import React from 'react';

import {ROLES} from './Menu';
import Option, {OptionProps} from './Option';
/**
 * Renders a footer option in a Menu.
 */
// eslint-disable-next-line react/prefer-stateless-function -- using a class component in order to preserve _role on defaultProps
export default class FooterOption<T> extends React.Component<OptionProps<T>> {
  static defaultProps = {
    _role: ROLES.FOOTER_OPTION,
    shouldEllipsize: false,
  };

  override render(): JSX.Element {
    // See Menu implementation -- the children are rendered as is, followed by a divider.
    return <Option {...this.props} />;
  }
}
